import numeral from 'numeral';
import currSymbol from 'currency-symbol-map';

const delimiters = {
  thousands: ',',
  decimal: '.',
};

const abbreviations = {
  thousand: 'k',
  million: 'm',
  billion: 'b',
  trillion: 't',
};

const ordinal = number => {
  switch (number) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

numeral.register('locale', 'GBP', {
  delimiters,
  abbreviations,
  ordinal,
  currency: { symbol: currSymbol('GBP') },
});

numeral.register('locale', 'USD', {
  delimiters,
  abbreviations,
  ordinal,
  currency: { symbol: currSymbol('USD') },
});

numeral.register('locale', 'EUR', {
  delimiters,
  abbreviations,
  ordinal,
  currency: { symbol: currSymbol('EUR') },
});

export default numeral;
